/*=============================================== DemoMainForm ===============================================*/

import { Text, Wrapper } from "tsx-library-julseb"

import { StyledMain, WrapperDemo } from "components"

const DemoMainForm = () => {
    return (
        <WrapperDemo title="Demo main form">
            <Wrapper>
                <StyledMain size="form">
                    <Text tag="h1">Main</Text>
                </StyledMain>
            </Wrapper>
        </WrapperDemo>
    )
}

export default DemoMainForm
